module.exports = __webpack_public_path__ + "static/media/upcoming_sip.df84a7bb.svg";